// if document is changed then this function will be called to update the cart drawer 
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const cartDrawer = document.querySelector('#cart-drawer');
const cartDrawerClose = document.querySelectorAll('#close-cart');
var loaderSkeleton = document.querySelector('.loader__skeleton');
const body = document.body;

// This function is used to fetch the cart drawer data from a end point i have created in the template with no layout containing the liquid code to append. 
async function refreshCartDrawer() {
  loaderSkeleton.style.display = 'block';
  fetch('/?view=cart-drawer')
    .then(function (response) {
      return response.text();
    })
    .then(function (cartData) {
      document.querySelector('.cart-drawer__body').innerHTML = cartData;
      loaderSkeleton.style.display = 'none';
      const elementsToRemove = document.querySelectorAll('[data-rebuy-id="86585"]');
      elementsToRemove.forEach((element) => element.remove());

      // Append a new div element with data-rebuy-id of "86585" to the last .cart-drawer-upsell__container element
      const newDiv = document.createElement('div');
      newDiv.dataset.rebuyId = '86585';
      const cartContainers = document.querySelectorAll('.cart-drawer-upsell__container');
      // if cartContainers is empty, return early to prevent error on next line of code 
      if (!cartContainers.length) {
        return;
      }
      const lastCartContainer = cartContainers[cartContainers.length - 1];
      lastCartContainer.appendChild(newDiv);
      // Initialize Rebuy if it exists
      if (window.Rebuy) {
        Rebuy.init();
      }
    });
}

document.addEventListener("rebuy:cart.change", function() { refreshCartDrawer(Rebuy.Cart.cart); });

async function toggleCartDrawer(isOpen) {
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
 
  if (isOpen) {
   
    setTimeout(() => {
      refreshCartDrawer();
      cartDrawer.style.transform = 'translateX(0)';
      cartDrawerOverlay.style.display = 'block';
      body.classList.add('cart-drawer-open');
      
    }, 300);
  } else {
    cartDrawer.style.transform = 'translateX(100%)';
    cartDrawerOverlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
  }
}


const toggleCartDrawerButtons = document.querySelectorAll('[toggle-cart-drawer]');
toggleCartDrawerButtons.forEach((button) => {
  button.addEventListener('click', () => toggleCartDrawer(true));
});

const elementsToTriggerCartDrawer = '.product-form--atc-button, .product-form-button__wrapper';
const elementsToTrigger = document.querySelectorAll(elementsToTriggerCartDrawer);
elementsToTrigger.forEach((element) => {
  element.addEventListener('click', () => {
    console.log('i was clicked');
      refreshCartDrawer();
      toggleCartDrawer(true);
  });
});

/// Function for close the cart drawer 
cartDrawerClose.forEach(function (button) {
  button.addEventListener('click', function () {
    cartDrawer.style.transform = 'translateX(100%)';
    document.querySelector('.cart-drawer-overlay').style.display = 'none';
    body.classList.remove('cart-drawer-open');
  });
});

// Function on click to add product from quick add to cart drawer

document.querySelector('body').addEventListener('click', function (e) {
  if (e.target.id === ('quick-add') || e.target.classList.contains('product-form--atc-button')) {
    refreshCartDrawer();
    toggleCartDrawer(true);
  }
});

// This function is for updating the quantity for each item in the cart drawer, and it is then calling the updateQunaity function

document.querySelector('.cart-drawer__body').addEventListener('click', function (e) {
  console.log(e.target.classList);
  if (e.target.classList.contains('cart-drawer-quantity__minus')) {
    console.log('minus clicked');
    const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
    const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
    const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
    if (quantity >= 1) {
      updateCart(itemId, quantity, 'updateItemQty');
    }
  }
  if (e.target.classList.contains('cart-drawer-quantity__plus')) {
    console.log('plus clicked');
    const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
    const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
    const quantity = parseInt(cartDrawerQuantityVal.value, 10) + 1;
    updateCart(itemId, quantity, 'updateItemQty');
  }
  if (e.target.classList.contains('cart-drawer__item-delete')) {
    console.log('delete clicked');
    const itemId = e.target.getAttribute('data-item-id');
    updateCart(itemId, 0,'removeItem' )
  }

  if (e.target.classList.contains('smart-cart-drawer-upsell-product-add')) {
    e.preventDefault();
    const upsellBtn = e.target;
    const upsellId = upsellBtn.getAttribute('data-varaint');
    const quantity = 1;
    addToCart(upsellId, quantity);
  }
});

// this function handles the update item quanity as well as the remove item from the cart as it takes the type as a parameter
async function updateCart(itemId, quantity, type) {
  try {
    // Fetch the current cart
    const res = await fetch('/cart.js'); 
    const cart = await res.json(); 
    const item = cart.items.find((item) => (item.key == itemId));

    // Check if the item is already at the desired quantity for update and return if true
    if (type === 'updateItemQty' && item.quantity === quantity) return;

    // Make a request to update or delete the item in the cart 
    let updatedRes;
    if (type === 'updateItemQty') {
       updatedRes = await fetch('/cart/change.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify({
           id: itemId,
           quantity: quantity
         })
       });
    } else if (type === 'removeItem') {
       updatedRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity
        })
       });
    }
    const updatedCart = await updatedRes.json();

    if (type === 'updateItemQty') {

        const updatedItem = updatedCart.items.find((item) => (item.key == itemId));
        const itemPrice = updatedItem.final_line_price;
        const moneyFormat = document.getElementById('cart-drawer').getAttribute('data-money-format');
        const cartDrawerSubtotalPrice = document.querySelector('.cart-drawer-subtotal__price');
        const cartDrawerItemPrice = document.querySelector(`[data-item-id="${itemId}"] .cart-drawer__item-price`);
        cartDrawerSubtotalPrice.innerHTML = formatMoney(updatedCart.total_price, moneyFormat);
        cartDrawerItemPrice.innerHTML = formatMoney(itemPrice, moneyFormat);

        refreshCartDrawer();

    } else if (type === 'removeItem') {
        loaderSkeleton.style.display = 'block';
        if (cart.items.length === 0) {
          cartDrawer.style.transform = 'translateX(100%)';
          document.querySelector('.cart-drawer-overlay').style.display = 'none';
          body.classList.remove('cart-drawer-open');
          document.querySelector('#cart-drawer__form').remove();
          const emptyState = document.createElement('div');
          emptyState.innerHTML = `
            <div class="cart-drawer__empty">
              <p class="cart-drawer__empty-text"> Your Basket is empty </p>
              <span> Add your favorite items to your cart.</span>
              <a class="cart-drawer__empty-btn" href="/"> Shop Now <a>
            </div>`;
          document.querySelector('.cart-drawer .cart-drawer__body').appendChild(emptyState);
        } else {
          const removeItem = document.querySelector('.cart-drawer__item[data-item-id="' + itemId + '"]');
    
          loaderSkeleton.style.display = 'none';
    
          removeItem.remove();
          await refreshCartDrawer();
        }
      }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

//get add to cart to work with collection page and its products. 
const quickAdd = document.querySelector('.modal.modal--quickshop-slim');
console.log(quickAdd);
if (quickAdd) {
  quickAdd.addEventListener('click', function (e) {
      if (e.target.classList.contains('product-form--atc-button')) {
          e.preventDefault();
          const inputValue = e.target.parentElement.querySelector('.variant-selection').value;
          const inputQuantity = e.target.parentElement.querySelector('input').value;
          addToCart(inputValue, inputQuantity);
      }
  });
}

